export const muiThemeBreakpoints = {
  xs: 100,
  sm: 480,
  md: 768,
  lg: 1250,
  xl: 1500,
};
